import AsignedReviewersList from './AsignedReviewersList.component';

export default AsignedReviewersList;
